import { createFileRoute, redirect } from "@tanstack/react-router";

import { ProjectsPage } from "@/features/projects/ProjectsPage";

export const Route = createFileRoute("/_app/projects/")({
  beforeLoad: ({ context }) => {
    const perms = context.me?.permissions ?? [];
    if (context.info.edition !== "cloud" || !(perms.includes("projects.manage") || perms.includes("config.manage"))) {
      throw redirect({ to: "/worklist" });
    }
  },
  component: ProjectsPage,
});
